module.exports = __webpack_public_path__ + "img/richie.237ab23b.png";